var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V14.0593C21.0001 14.0681 21.0001 14.0769 21 14.0857V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13.1617C2.99964 13.1463 2.99964 13.1308 3 13.1153V5ZM19 5V12.7231C18.4981 12.5335 17.8645 12.2986 17.1371 12.1505C15.5945 11.8361 13.7098 11.9267 11.48 13.2842C9.76924 14.3258 8.46932 14.1984 7.41346 13.8027C6.8513 13.592 6.34146 13.2972 5.83822 12.9926C5.78919 12.9629 5.73883 12.9321 5.68735 12.9007L5.68638 12.9001L5.6853 12.8995C5.47111 12.7688 5.23759 12.6263 5 12.4979V5H19ZM5 19V14.8223C5.4774 15.1069 6.05464 15.4293 6.71154 15.6755C8.28068 16.2636 10.2308 16.3863 12.52 14.9925C14.2902 13.9148 15.6555 13.8897 16.7379 14.1102C17.3068 14.2261 17.8174 14.4141 18.326 14.6064L18.4225 14.643L18.4225 14.643L18.4225 14.643C18.6025 14.7114 18.798 14.7856 19 14.8533V19H5ZM8 9C8 8.44772 8.44772 8 9 8C9.55229 8 10 8.44772 10 9C10 9.55228 9.55229 10 9 10C8.44772 10 8 9.55228 8 9ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.d1245ae3.svg";
export { ForwardRef as ReactComponent };